import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShellComponent } from './shell/shell.component';
import { IntegrationsComponent } from '../features/integrations/integrations.component';

const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
  },
  {
    path: 'integrations',
    component: IntegrationsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LayoutRoutingModule {}
